import classNames from 'classnames';

import ccBackImage from '../../assets/cc-mini-back.png';
import ccBack2xImage from '../../assets/cc-mini-back@2x.png';
import ccFrontImage from '../../assets/cc-mini-front.png';
import ccFront2xImage from '../../assets/cc-mini-front@2x.png';

import styles from './CVVIcon.module.scss';

const IMAGES = {
  cvvBack: {
    lowRs: ccBackImage,
    highRs: ccBack2xImage,
    dataZta: 'ccBackImage',
  },
  cvvFront: {
    lowRs: ccFrontImage,
    highRs: ccFront2xImage,
    dataZta: 'ccFrontImage',
  },
};

export type CVVIconType = keyof typeof IMAGES;

interface CVVIconProps {
  isAmex?: boolean;
  className?: string;
}

const CVVIcon = ({ isAmex, className }: CVVIconProps) => {
  const type: CVVIconType = isAmex ? 'cvvFront' : 'cvvBack';
  const image = IMAGES[type];
  return image ? (
    <img
      className={classNames(styles.cvvIcon, className)}
      src={image.lowRs}
      alt={type}
      srcSet={`${image.lowRs} 1x, ${image.highRs} 2x`}
      data-zta={image.dataZta}
    />
  ) : null;
};

export default CVVIcon;
